export const getStyles = (theme: any) => ({
	logoContainer: {
		maxHeight: '100%',
	},
	logo: {
		// maxHeight: '33px',
		maxWidth: '100%',
	},
});
